var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
/**
 * @hidden
 */

export function HeaderCell(props) {
  var clickProps = props.onClick ? {
    href: '#',
    onClick: props.onClick
  } : {};
  var defaultRendering = React.createElement("a", __assign({
    className: "k-link"
  }, clickProps), props.title || props.field || "\xA0", props.children);
  return props.render ? props.render.call(undefined, defaultRendering, props) : defaultRendering;
}